import { type LucideProps } from 'lucide-react'

export default function Jira(props: LucideProps) {
  return (
    <svg width='28' height='28' viewBox='0 0 28 28' fill='none' {...props}>
      <path
        d='M27.6647 13.2165L15.2075 1.1679L14 0L4.62269 9.06969L0.33526 13.2165C-0.111753 13.6494 -0.111753 14.3506 0.33526 14.7835L8.90247 23.0697L14 28L23.3773 18.9303L23.5225 18.7899L27.6647 14.7835C28.1118 14.3506 28.1118 13.6494 27.6647 13.2165ZM14 18.1394L9.72022 14L14 9.86061L18.2798 14L14 18.1394Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M14.0001 9.86061C11.198 7.15013 11.1843 2.76 13.9695 0.0332619L4.60364 9.08817L9.70117 14.0185L14.0001 9.86061Z'
        fill='url(#paint0_linear_1_12781)'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M18.2912 13.9889L14 18.1394C15.3525 19.4467 16.1124 21.2203 16.1124 23.0697C16.1124 24.9191 15.3525 26.6926 14 28L23.3888 18.9192L18.2912 13.9889Z'
        fill='url(#paint1_linear_1_12781)'
      />
      <defs>
        <linearGradient
          id='paint0_linear_1_12781'
          x1='13.2358'
          y1='5.67318'
          x2='6.09658'
          y2='8.79029'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0.18' stopColor='currentColor' stopOpacity='0.5' />
          <stop offset='1' stopColor='currentColor' stopOpacity='1' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_1_12781'
          x1='14.8177'
          y1='22.2788'
          x2='21.9441'
          y2='19.1838'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0.18' stopColor='currentColor' stopOpacity='0.5' />
          <stop offset='1' stopColor='currentColor' stopOpacity='1' />
        </linearGradient>
      </defs>
    </svg>
  )
}
